<div class="aumico-intro-root">
    <div class="aumico-intro-header">
        <img class="aumico-logo" src="assets/aumico-logo-4c-white.svg" />
    </div>
    <div>
        <ng-container>
            <ng-content select="[aumico-intro-layout-side-content]"></ng-content>
        </ng-container>
    </div>
    <div class="page-content-wrapper">
        <div class="page-content">
            <ng-content></ng-content>
        </div>
    </div>
    <!-- < intro-layout-footer> -->
    <div class="footer-position">
        <ng-content select="[aumico-intro-footer]"></ng-content>
    </div>
    <!-- Language Switch -->
    <div class="language-switch-and-navigation">
        <span *ngIf="showBackButton" class="ham-icon" (click)="onNavigateToLogin()" style="cursor: pointer">
            <i class="arrow-left-outline-icon"></i>
        </span>
        <span *ngIf="!showBackButton"> </span>
        <div class="language-switch">
            <select
                class="language-selector"
                [(ngModel)]="currentLanguage"
                (ngModelChange)="onLanguageChangeModel($event)"
                aria-label="Select Language"
            >
                <option *ngFor="let lang of availableLanguages" [value]="lang.code">
                    {{ lang.key | i18next }}
                </option>
            </select>
        </div>
    </div>
</div>
